// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"f1e95b4e","468":"dfab11ae"}[chunkId] + ".chunk.js";
};